module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 319
// module chunks = 0